import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://api.forestdigitalservices.com/api/qrmenu',
    // baseURL: 'http://localhost:4000/api/qrmenu',
    withCredentials: true
})

export default instance